import { Center, Text } from '@chakra-ui/react'
import { usePracticeAccess } from '@hb/react'
import { PageContainer, VisitsCalendar } from '@hb/react-web'

export const VisitsView = () => {
  const { selectedPracticeId } = usePracticeAccess()
  if (!selectedPracticeId)
    return (
      <Center>
        <Text>no practice selected</Text>
      </Center>
    )
  return (
    <PageContainer contentProps={{ flex: 1 }} fullWidth overflowY="auto">
      <VisitsCalendar practiceId={selectedPracticeId} />
    </PageContainer>
  )
}
